const KEY = "ais_oral_progress_v1";

export function loadProgress() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch (err) {
    console.error("[progress] localStorage read failed", err);
    return {};
  }
}

export function saveProgress(progress) {
  try {
    localStorage.setItem(KEY, JSON.stringify(progress));
  } catch (err) {
    console.error("[progress] localStorage write failed", err);
  }
}

export function toggleMastered(progress, questionId) {
  const next = { ...progress };
  if (next[questionId]?.mastered) {
    delete next[questionId];
  } else {
    next[questionId] = { mastered: true, ts: Date.now() };
  }
  saveProgress(next);
  return next;
}

export function isMastered(progress, questionId) {
  return Boolean(progress[questionId]?.mastered);
}

export function countMastered(progress) {
  return Object.values(progress).filter((v) => v?.mastered).length;
}
